import { Button, Form, Input, Modal, Select } from "antd";

import { selectFormOptionsNoFormatting } from "../../../../../../utils/helper";

const CreateEditHintModal = ({
  isModalOpen = false,
  isEdit = false,
  setIsModalOpen = () => {},
  initialValues = {},
  handleCreateEdit = () => {}
}) => {
  const [form] = Form.useForm();
  return (
    <Modal
      title="Create/Edit Hint"
      centered
      open={isModalOpen}
      footer={[]}
      onOk={() => {
        setIsModalOpen(false);
      }}
      onCancel={() => setIsModalOpen(false)}
    >
      <Form
        form={form}
        initialValues={isEdit ? initialValues : {}}
        name="new_subsection_form"
        onFinish={handleCreateEdit}
      >
        <Form.Item
          name="title"
          label="Title"
          rules={[
            {
              required: true,
              message: "Please enter a title!"
            }
          ]}
        >
          <Select
            options={selectFormOptionsNoFormatting(["Hint 1", "Hint 2", "Bonus"])}
            showSearch
            allowClear
          />
        </Form.Item>
        <Form.Item
          name="content"
          label="Content"
          rules={[
            {
              required: true,
              message: "Please enter a latex base hint"
            }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item className="submit-btn">
          <Button type="primary" htmlType="submit">
            {isEdit === true ? "Update" : "Create"} Hint
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateEditHintModal;
